// extracted by mini-css-extract-plugin
module.exports = {"widgetToolPopup":"style_widgetToolPopup__XFYe1","widgetPanelHeader":"style_widgetPanelHeader__0ga0A","navBar":"style_navBar__gZ22X"};